import { EditClientContractTermHeaderPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 編集ヘッダー Container コンポーネント
 *
 * ## 構成
 * - パンくず末尾の実企業名表示・契約プラン情報の表示: T02（PEN-979）で実装予定
 *
 * ## 後続チケット
 * - T02（PEN-979）: DetailHeader 実装（パンくず・契約プラン情報の表示）
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 */
export const EditClientContractTermHeader: React.FC<Props> = () => (
  <EditClientContractTermHeaderPresentation />
);
